import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsDestinationViewModel} from "../../../../domain/standings/models/destinations/standings.destinations.view-model";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {StandingsWidgetCompetitorTrend} from "./standings-widget.competitor.trend";
import {StandingsWidgetCompetitorWinnerLogo} from "./standings-widget.competitor.winner-logo";

export class StandingsWidgetCompetitorPositionProps extends BaseProps {
  row: StandingsDestinationViewModel;
}

export const StandingsWidgetCompetitorPosition = observer(({row}: StandingsWidgetCompetitorPositionProps) => {
  const {position} = row;

  return (
    <div className={classNames(styles.competitor_index)}>
      <StandingsWidgetCompetitorTrend row={row}/>
      <StandingsWidgetCompetitorWinnerLogo row={row}/>
      {position}
    </div>
  )
});
